<template>
<div id="home">
  <my-header ></my-header>
  <div class="pd20">
    
    <ul class="breadcrumb" >
      <li><router-link :to="{ name: 'ManageTracking'}">{{'Manage tracking'|translate}}</router-link></li>
      <li ><router-link :to="{ name: 'ManageBlock'}">{{'Manage blocks'|translate}}</router-link></li>
      <li v-if="block"><router-link :to="{ name: 'ManagePeriod', params: { block_id: block.id }}">{{block.name}}</router-link></li>
      <li v-if="period">{{period.name}}</li>
    </ul>
      <h3>{{'Manage seasons'|translate}}</h3>
      
      <div class="row" >
          <div class="col-md-5 mt20">
              <a class='btn btn-primary' v-on:click="showModal(null)">{{'Add season'|translate}}</a>
          </div>
          <div class="col-md-7 mt20">
              <input type="text" class="form-control" v-model="keyword"  v-on:keypress.enter.prevent="search()" :placeholder="'Search'|translate"  />
          </div>
          
      </div>

      <loading v-if="list_items == null" class="mt20"  :text="'Please wait'|translate"></loading>
        
        <p class="mt20 alert alert-info"  v-if="list_items && list_items.length == 0">{{'There is no data'|translate}}</p>
        <table class="table mt10" v-if="list_items && list_items.length > 0" >
        <thead>
            <tr>
            <th>{{'Name'|translate}}</th>
            <th>{{'Start date'|translate}}</th>
            
            <th>{{'Estimate quantity'|translate}}</th>
            <th>{{'Count Histories'|translate}}</th>
            <th>{{'Count Harvests'|translate}}</th>
            <th>{{'Period'|translate}}</th>
            <th>{{'Action'|translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item) in list_items" :key="item.id">
                <td><router-link :to="{ name: 'ManageHistory', params: { season_id:item.id }}">{{item.name}}</router-link></td></td>
                <td>{{ item.start_date | moment("DD/MM/YYYY") }}</td>
                
                <td>{{ item.quantity_estimate }}</td>
                <td>{{ item.count_histories }}</td>
                <td>{{ item.count_harvests }}</td>
                <td>{{ item.period_name }}</td>
                <td>
                   <a class="btn btn-danger" v-on:click="removeItem(item)" :disabled="removing" >{{'Delete'|translate}}</a>
                   
                    <a class="btn btn-info" v-bind:class="{disabled:item.remain_text == 0}"  v-on:click="showModal(item)">
                        {{'Update'|translate}} <span v-if="item.remain_text != 0" >[{{item.remain_text}}]</span> 
                    </a>
                    
                </td>
            </tr>
        </tbody>
        </table>
        <paginate
        v-if="total_page > 1"
        :page-count="total_page"
        :click-handler="clickPage"
        :prev-text="'Prev'|translate"
        :next-text="'Next'|translate"
        v-model="page"
        :container-class="'pagination'">
        </paginate>
  </div>
  <form-season v-if="show_form" ref="form" :period_id=period_id :pass_data="pass_data"  @modalData="modalData"  ></form-season>
</div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import FormSeason from '@/components/Cultivation/FormSeason'
import Paginate from 'vuejs-paginate'
import Loading from '@/components/elements/Loading'
export default {
  name: 'ManageSeason',
  components: {
    MyHeader,
    FormSeason,
    Paginate,
    Loading
  },
  data () {
    return {
        show_form: false,
        pass_data: null,
        list_items: null,
        removing: false,
        page:1,
        offset:0,
        keyword:'',
        limit:Utils.getLimit(),
        total_page:1,
        period_id:null,
        period:null,
        block:null
    }
  },
  methods: {
      modalData(data){
          this.list()
      },
      showModal(data){
        this.show_form = true
        
        this.pass_data = data != null ? JSON.parse(JSON.stringify(data))  : data
        
        
        setTimeout(() => {
            this.$refs.form.open()
        })
      },
      list(){
        let data = {
            offset:this.offset,
            limit:this.limit,
            keyword: this.keyword,
            period_id: this.period_id
        }
        Utils.request(this, true,'land').get(`/manageSeason/?${Utils.arrayToRequestParam(data)}`).then(response => {
            let data = response.data
            if (data.status === 'ok'){
                let list = data.data.list
                this.block = data.data.block
                this.period = data.data.period
                list = list.map((item) =>{
                    let temp = new Date(parseInt(item.add_time) * 1000)
                    item.add_date = this.$moment(temp)

                    let temp1 = new Date(parseInt(item.start_time) * 1000)
                    item.start_date = this.$moment(temp1)
                    if (item.finish_time){
                        temp1 = new Date(parseInt(item.finish_time) * 1000)
                        item.finish_date = this.$moment(temp1)
                    }
                    
                    item.remain_text = Utils.getFormattedTime( this, item.add_date)
                    return item
                })
                this.list_items = list
                
                this.total_page = Utils.getTotalPages(data.data.count)
                
                // update local storage
            }
        })
        .catch(error => {
            this.updating = false
            Utils.showErrorMessage(this, error.response)
        })
      },
      
    removeItem (item) {
      this.$alertify.confirmWithTitle(this.$t('Confirm'), this.$t('Are you sure to remove this item ?'), () => {
        this.removing = true
        Utils.request(this, true,'land').delete(`/manageSeason/${item.id}`).then(response => {
            this.removing = false
            let data = response.data
            console.log('data',data)
            if (data.status === 'ok'){
                this.offset = 0
                this.list()
            }
             else {
                Utils.showError(this, data.data);
              }
        })
      })
    },
    clickPage(pageNum){
        this.offset = Utils.getNextOffset(pageNum)
        this.list()
    },
    search(){
        this.offset = 0
        this.list()
    }
  },
  mounted(){
      this.period_id = this.$route.params.period_id
      this.list()
      
      this.$options.interval = setInterval(()=>{
          Utils.updateDateTime(this)
      }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.$options.interval);
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Cultivation/ManageSeason.vue